import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import Strong from '@tds/core-strong';

import { Thead, Tr, Th, Td } from './css';
import getFormattedPricing from '../../utils';
import Row from './row';

const Table = ({
  isRenewal,
  viewType,
  ratePlans,
  hardware,
  setHardware,
  list,
  total,
  setTotal
}) => {
  const getHeader = headerList => (
    <Thead>
      <Tr>
        {headerList.map(item => (
          <Th>{_.get(item, 'fields.title', '')}</Th>
        ))}
      </Tr>
    </Thead>
  );

  useEffect(() => {
    const grandTotal = Object.keys(hardware).reduce((acc, current) => {
      const { unitPrice, additionalQuantity } = hardware[current];
      if (unitPrice && additionalQuantity)
        return acc + unitPrice * +additionalQuantity;
      return acc;
    }, 0);
    setTotal(previousValue => ({ ...previousValue, hardware: grandTotal }));
  }, [hardware]);

  return (
    <table>
      {list.map(hardwareItem =>
        _.get(hardwareItem, 'fields.isHeader', false) ? (
          getHeader(
            _.get(
              hardwareItem,
              `fields.${isRenewal ? 'headerListRenewal' : 'headerList'}`,
              []
            )
          )
        ) : (
          <Row
            key={_.get(hardwareItem, 'sys.id', '')}
            rowData={hardwareItem}
            isRenewal={isRenewal}
            viewType={viewType}
            ratePlans={ratePlans}
            hardware={hardware}
            setHardware={setHardware}
          />
        )
      )}
      <Tr style={{ background: '#f4f4f4' }}>
        <Td colSpan={isRenewal ? 3 : 5}>
          <Strong>Total</Strong>
        </Td>
        <Td>
          <Strong>{getFormattedPricing(total)}</Strong>
        </Td>
      </Tr>
    </table>
  );
};

Table.propTypes = {
  isRenewal: PropTypes.bool.isRequired,
  viewType: PropTypes.string.isRequired,
  ratePlans: PropTypes.arrayOf(PropTypes.object).isRequired,
  hardware: PropTypes.arrayOf(PropTypes.object).isRequired,
  setHardware: PropTypes.func.isRequired,
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired
};

export default Table;
